/* Shopify homepage enhancement. Load once with defer, after existing theme scripts. */
(() => {
  if (window.sparkMobileHomeLoaded) return;
  window.sparkMobileHomeLoaded = true;
  const mobile = matchMedia('(max-width:760px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const live = new Map();
  const clamp = (n, max) => Math.max(0, Math.min(max, n));
  function setup(section) {
    if (live.has(section)) return;
    const track = section.querySelector('.flavour-track,.science-track');
    if (!track) return;
    const abort = new AbortController(), signal = abort.signal;
    let panel, distance = 0, top = 0, expected = 0, frame = 0;
    const dots = [...section.querySelectorAll('[data-flavour-slide]')];
    const cards = [...track.querySelectorAll('.flavour-panel,.science-card')];
    function indicators() {
      const left = track.getBoundingClientRect().left;
      const active = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(cards[best].getBoundingClientRect().left-left) ? i : best, 0);
      dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i===active)));
    }
    function paint() {
      frame = 0;
      if (!panel) return;
      expected = clamp(top-section.getBoundingClientRect().top, distance);
      if (Math.abs(track.scrollLeft-expected) > .5) track.scrollLeft = expected;
      indicators();
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(paint); }
    function unwrap() {
      if (!panel) return;
      panel.replaceWith(...panel.childNodes);
      panel = null;
      section.classList.remove('mobile-scroll-section');
      section.style.removeProperty('--mobile-scroll-height');
      section.style.removeProperty('--mobile-scroll-top');
    }
    function build() {
      unwrap();
      if (!mobile.matches || reduced.matches) return;
      distance = track.scrollWidth-track.clientWidth;
      if (distance <= 1) return;
      panel = document.createElement('div');
      panel.className = 'mobile-scroll-panel';
      panel.append(...section.childNodes); section.append(panel);
      section.classList.add('mobile-scroll-section');
      const height = panel.getBoundingClientRect().height;
      // Start 120px below the top; keep the entire card accessible on short screens.
      top = Math.min(120, document.documentElement.clientHeight-height);
      section.style.setProperty('--mobile-scroll-height', `${height+distance}px`);
      section.style.setProperty('--mobile-scroll-top', `${top}px`);
      paint();
    }
    track.addEventListener('scroll', () => {
      indicators();
      if (!panel || Math.abs(track.scrollLeft-expected) < 2) return;
      const start = scrollY+section.getBoundingClientRect().top-top;
      if (scrollY >= start-1 && scrollY <= start+distance+1) {
        expected=track.scrollLeft;
        scrollTo({top:start+expected,behavior:'instant'});
      }
    }, {passive:true,signal});
    dots.forEach((dot,i) => dot.addEventListener('click', () => {
      const x = clamp(cards[i].offsetLeft-cards[0].offsetLeft,track.scrollWidth-track.clientWidth);
      if (panel) scrollTo({top:scrollY+section.getBoundingClientRect().top-top+x,behavior:'smooth'});
      else track.scrollTo({left:x,behavior:reduced.matches?'instant':'smooth'});
    }, {signal}));
    addEventListener('scroll',schedule,{passive:true,signal});
    let timer;
    addEventListener('resize',()=>{clearTimeout(timer);timer=setTimeout(build,150);},{signal});
    reduced.addEventListener('change',build,{signal});
    // Existing hover-video code continues to own .product-photo; no duplicate handlers.
    const state={destroy(){abort.abort();clearTimeout(timer);cancelAnimationFrame(frame);unwrap();},build};
    live.set(section,state);
    build(); indicators();
    document.fonts?.ready.then(()=>{if(live.has(section)) build();});
  }
  function orderSections() {
    const selectors=['hero','intro','box','flavours','park','pouch-photo','moments','minerals','quote','transparent','clarity','journal','recommended'];
    selectors.forEach((name,i)=>document.querySelectorAll(`[id^="Spark-"]`).forEach(section=>{
      if (!section.classList.contains(name)) return;
      const wrapper=section.closest('.shopify-section');
      if (!wrapper) return;
      wrapper.style.setProperty('--spark-mobile-order',i+1);
      wrapper.parentElement.classList.add('spark-home-sections');
    }));
  }
  function init() {orderSections();document.querySelectorAll('[id^="Spark-"] .flavour-track,[id^="Spark-"] .science-track').forEach(track=>setup(track.closest('section')));}
  document.addEventListener('shopify:section:unload',event=>{
    for(const [section,state] of live) if(event.target.contains(section)){state.destroy();live.delete(section);}
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',orderSections);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
